<!-- Generator: Adobe Illustrator 28.1.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg enable-background='new 0 0 250 205' height='205px' version='1.1' viewBox='0 0 250 205' width='250px'
     x='0px' xml:space='preserve' xmlns='http://www.w3.org/2000/svg' y='0px'>
<g id="graphics">
	<path d="M179.5,176.5h-1.8h-31.2l0,24h-7.4h-7.6l0-24H99.7h-2.2V58
		l1.4-1.5h3.9c2.3,0.8,4.5,1.9,5.9,3.6l25.1,31.3c2.9,3,7.7,3,10.6,0l24.8-31.2c1.4-1.8,3.6-2.9,5.9-2.7h3.9l0.5,0.5L179.5,176.5z" fill="#9A9A9A" stroke="#707070" stroke-miterlimit="10"
  />
  <path d="M191.5,35.1L154,75.4
		c-8.1,8.7-21.9,8.7-30.1,0L65.5,13.1l7-8L132,68.4c3.8,4.1,10.3,4.1,14.1,0l38.5-41.3L191.5,35.1z" fill="#DADADA" stroke="#707070" stroke-linejoin="round" stroke-miterlimit="10"/>
  <line fill="none" stroke="#285172" stroke-miterlimit="10" x1="108.5" x2="108.5" y1="60" y2="119"/>
  <line fill="none" stroke="#285172" stroke-miterlimit="10" x1="169.5" x2="169.5" y1="60" y2="119"/>
  <g>
		<g>
			<line fill="none" stroke="#285172" stroke-miterlimit="10" x1="78" x2="90.8" y1="60.5" y2="46.5"/>
      <g>
				<polygon fill="#285172" points="92.2,48.7 93.3,43.9 88.5,45.4 				"/>
			</g>
		</g>
	</g>
  <g>
		<g>
			<line fill="none" stroke="#285172" stroke-miterlimit="10" x1="115.7" x2="104.4" y1="20.3" y2="32.4"/>
      <g>
				<polygon fill="#285172" points="103.1,30.1 102,35 106.8,33.5 				"/>
			</g>
		</g>
	</g>
  <g>
		<g>
			<line fill="none" stroke="#285172" stroke-miterlimit="10" x1="112.6" x2="165.4" y1="112.5" y2="112.5"/>
      <g>
				<polygon fill="#285172" points="113.3,115 109,112.5 113.3,110 				"/>
			</g>
      <g>
				<polygon fill="#285172" points="164.7,115 169,112.5 164.7,110 				"/>
			</g>
		</g>
	</g>
</g>
  <g id="texts">
	<rect fill="none" height="45" width="82" x="98" y="117.2"/>

    <text fill="#285172" font-family="'OpenSans'" font-size="12px" id="dieWidth" transform="matrix(1 0 0 1 104.0996 132.0303)">{{dieWidth}}</text>
    <polygon fill="none" points="75.5,82.7 6.7,82.7 6,37.7 74.8,37.7 	"/>

    <text fill="#285172" font-family="'OpenSans'" font-size="12px" id="sheetThickness" transform="matrix(1 0 0 1 36.8782 46.5718)">{{sheetThickness}}</text>
</g>
</svg>
